import http from './request'
import {message} from 'ant-design-vue'
// 去除0结尾的方法
export function removeZero (num) {
  if (num.toString().indexOf('.') !== -1) {
    return parseFloat(num.toString().replace(/0+$/, ''))
  } else {
    return num
  }
}

// 根据名字长度截取名字后两位显示
export function cutUserName (nameVal) {
  if (nameVal) {
    if (nameVal.length >= 3) {
      return nameVal.slice(-2)
    } else if (nameVal.length <= 2) {
      return nameVal
    }
  }
}

/*
  头像存在 => 包含'dingtalk'则为钉钉自己设置的头像
          => 本地默认图片路径 - 改成自己名称
  头像不存在 => 名字后两位
*/
export function isAvatat (imgUrl) {
  if (imgUrl) {
    if (imgUrl.includes('dingtalk')) {
      return imgUrl
    } else {
      return ''
    }
  } else {
    return ''
  }
}

/*
 * 金额：元 换算 万
 * @param  je 金额参数
*/
export function setJine (je) {
  if (je >= 10000) {
    return parseFloat((je / 10000).toFixed(2))
  } else {
    return je
  }
}

/*
 * 单位：元 换算 万
 * @param  mo 参数
*/
export function setUnit (mo) {
  if (mo >= 10000) {
    return '万'
  } else {
    return '元'
  }
}

/**
 *
 * @param data 需要去重的数组
 * @param key 唯一标识符
 * @returns {unknown[]}
 */
export function uniqur (data, key) {
  const obj = {}
  data.forEach(t => {
    if (!obj[t[key]]) {
      obj[t[key]] = t
    }
  })
  return Object.values(obj)
}

/**
 * 根据客户id查询客户name
 * @param customerId 客户id
 */
export function getCustomerNameById (customerId) {
  return new Promise((resolve, reject) => {
    http.get(`/customer/list`, { id: customerId }).then(res => {
      if (res.data.status === 1) {
        resolve(res.data.data.rows[0].companyName)
      }
    })
  })
}

/**
 * 根据合同id查询合同name
 * @param contractId 合同id
 */
export function getContractNameById (contractId) {
  return new Promise((resolve, reject) => {
    if (contractId) {
      http.get(`/contract/listById`, { id: contractId }).then(res => {
        if (res.data.status === 1) {
          resolve(res.data.data.contractTitle)
        }
      })
    }
  })
}

/**
 * 根据项目id查询项目name
 * @param projectId 项目id
 */
export function getProjectNameById (projectId) {
  return new Promise((resolve, reject) => {
    if (projectId) {
      http.get(`project/list`, { id: projectId }).then(res => {
        if (res.data.status === 1) {
          resolve(res.data.data.rows[0].subject)
        }
      })
    }
  })
}

/**
 * 根据采购单id查询采购单name
 * @param purchaseId 采购单id
 */
export function getPurchaseNameById (purchaseId) {
  return new Promise((resolve, reject) => {
    if (purchaseId) {
      http.get(`/purchase/listById`, { id: purchaseId }).then(res => {
        if (res.data.status === 1) {
          resolve(res.data.data.subject)
        }
      })
    }
  })
}

/**
 * 根据checkType查询默认查送人
 * @param checkType 数据类型  0费用报销 1采购单 2预支预付  3付款计划  4回款记录
 */
export function getDefaultCarbonPerson (checkType) {
  return new Promise((resolve, reject) => {
    http.get(`/checkTemplate/getCheckCopy`, { checkType: checkType }).then(res => {
      if (res.data.status === 1) {
        resolve(res.data.data)
      } else {
        reject(res.data.message)
      }
    })
  })
}

// 根据传入的类型, 与参数，返回对象给回调函数
export function getListStatistics (type, params = {}, callback) {
  http.get(`${type}/statistics`, params).then(res => {
    if (res.data.status === 1) {
      callback(res.data.data)
    } else {
      message.error(res.data.message)
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/index.js